import Cookies from 'js-cookie';

import * as Url from 'pages/common/helpers/url-helpers';

const GOOGLE_PLACE_ACTION_LINK_COOKIE_NAME = {
  RWG_TOKEN: 'oc.googlePlaceActionLink.rwgToken',
  MERCHANT_ID: 'oc.googlePlaceActionLink.merchantId',
};

export const googlePlaceActionLink = {
  /**
   * Captures the conversion parameter of the Google Place Action link (aka. Google Book button).
   * https://developers.google.com/actions-center/verticals/local-services/redirect/integration-steps/conversion-tracking
   *
   * @param search - query string of the current URL.
   * @param clinicId - profile page clinic id.
   */
  captureConversionParams: (search, clinicId) => {
    const [rwgToken] = Url.getParam(search, 'rwg_token');

    if (!rwgToken || !clinicId) {
      return;
    }

    // The token should be persisted across the different searches and visits so store it in the cookies for 30 days.
    // https://developers.google.com/actions-center/verticals/local-services/redirect/integration-steps/conversion-tracking#persisting_the_rwg_token
    const cookieOptions = {
      expires: 30,
    };
    Cookies.set(
      GOOGLE_PLACE_ACTION_LINK_COOKIE_NAME.RWG_TOKEN,
      rwgToken,
      cookieOptions,
    );
    Cookies.set(
      GOOGLE_PLACE_ACTION_LINK_COOKIE_NAME.MERCHANT_ID,
      String(clinicId),
      cookieOptions,
    );
  },

  getConversionData: () => ({
    rwgToken: Cookies.get(GOOGLE_PLACE_ACTION_LINK_COOKIE_NAME.RWG_TOKEN),
    merchantId: Cookies.get(GOOGLE_PLACE_ACTION_LINK_COOKIE_NAME.MERCHANT_ID),
  }),

  resetConversionData: () => {
    Cookies.remove(GOOGLE_PLACE_ACTION_LINK_COOKIE_NAME.RWG_TOKEN);
    Cookies.remove(GOOGLE_PLACE_ACTION_LINK_COOKIE_NAME.MERCHANT_ID);
  },
};
